<template>
    <div class="bg-white p-8">
        <div>

            <div class="flex items-center">
                <svg class="text-green-500 w-10 h-10 pr-2 inline-block" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path clip-rule="evenodd" fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"></path>
                </svg>
                <h1 class="text-xl inline-block">A verification link has been sent to your email.</h1>
            </div>
        </div>
        <hr class="py-2 mt-3">
        <p>Please click on the link in the email to activate your account.  Didn't receive an email?  Please check your spam folder, or click below to resend </p>

        <div v-if="sent"><p class="mt-8">Your verification email has been sent.  You can send another one in a few seconds</p></div>
        <AppButton v-else @click="send" class="mt-3" variant="blue">Resend Verification Email</AppButton>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            sent: false,
        };
    },
    methods: {
        send() {
            axios.post('/email/send-verification').then((response) => {
                this.sent = true;

                setTimeout(() => {
                    this.sent = false;
                }, 10000);
            });
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
